export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4795.00096dc1.jpg";